import { render, staticRenderFns } from "./authorizedStore.vue?vue&type=template&id=45d45933&scoped=true"
import script from "./authorizedStore.vue?vue&type=script&lang=js"
export * from "./authorizedStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d45933",
  null
  
)

export default component.exports